import {
  Tooltips
} from "./chunk-TZ7NDB2R.mjs";
import {
  useHover
} from "./chunk-EVE3IGZR.mjs";

// lib/components/copiable-label/copiable-label/copiable-label.tsx
import { useState } from "react";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
var CopiableLabel = ({ label, icon, ...props }) => {
  const { hovering, hoverSensor } = useHover();
  const [copied, setCopied] = useState(false);
  const [ref, setRef] = useState(null);
  return /* @__PURE__ */ jsxs(
    "span",
    {
      ...props,
      style: {
        display: "flex",
        alignItems: "center",
        gap: "0.25em",
        cursor: "pointer",
        ...props.style
      },
      ref: setRef,
      onClick: () => {
        navigator.clipboard.writeText(label);
        setCopied(true);
      },
      onMouseEnter: hoverSensor.onMouseEnter,
      onMouseLeave: (e) => {
        hoverSensor.onMouseLeave(e);
        setCopied(false);
      },
      children: [
        icon,
        /* @__PURE__ */ jsx("span", { children: label }),
        /* @__PURE__ */ jsx(
          Tooltips,
          {
            isActive: hovering,
            refElement: ref,
            label: copied ? /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx("span", { className: "icon", children: /* @__PURE__ */ jsx("i", { className: "fas fa-check" }) }),
              "\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F"
            ] }) : "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30B3\u30D4\u30FC\u3059\u308B"
          }
        )
      ]
    }
  );
};

export {
  CopiableLabel
};
